<script setup lang="ts">
import { onMounted } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { useLocationStore } from '@/store/modules/location'
import { initSession, getLocationByIp } from '@/api/user'
import { getSessionId, setSessionId } from '@/utils/token'
import KeFu from '@/components/keFu/keFu.vue'

const userStore = useUserStore()
const locationStore = useLocationStore()

onMounted(async () => {
  // 初始化 session
  if (!getSessionId()) {
    try {
      const res = await initSession('web') as any
      if (res?.data) {
        userStore.setSessionId(res.data)
      } else if (res?.msg) {
        userStore.setSessionId(res.msg)
      }
    } catch {}
  }

  // IP 定位
  try {
    const res = await getLocationByIp() as any
    if (res?.data) {
      locationStore.setLocation(res.data)
    }
  } catch {}
})
</script>

<template>
  <router-view :key="$route.path" />
  <KeFu />
</template>
